// import { connectRouter } from 'connected-react-router'; // Removed in v6
// import { History } from 'history'; // Removed in v6
import { combineReducers, Reducer } from 'redux';

import { ActionType } from '../actionTypes';
import { Action } from '../types';
import analysisConfigReducer from './analysis/reducer';
import availabilityStatsReducer from './availability/reducer';
import campaignsReducer from './campaigns/reducer';
import entitiesReducer from './entities/reducer';
import eventsReducer from './events/reducer';
import experimentCountryReducer from './experimentCountry/reducer';
import experimentsReducer from './experiments/reducer';
import interferencesReducer from './interferences/reducer';
import localFlagsReducer from './localFlags/reducer';
import maxAvailablePopulationReducer from './population/reducer';
import analysisReportReducer from './reports/reducer';
import rolloutHistoryReducer from './rolloutHistory/reducer';
import rolloutReducer from './rollouts/reducer';
import State from './State';
import userReducer from './users/reducer';
import variablesReducer from './variables/reducer';
import variableStatsReducer from './variableStats/reducer';

const createRootReducer = (): Reducer<State, Action<ActionType>> =>
  combineReducers<State, Action<ActionType>>({
    // router: connectRouter(history), // Removed in v6
    variables: variablesReducer,
    entities: entitiesReducer,
    experiments: experimentsReducer,
    events: eventsReducer,
    rollouts: rolloutReducer,
    rolloutHistory: rolloutHistoryReducer,
    campaigns: campaignsReducer,
    localFlags: localFlagsReducer,
    experimentCountry: experimentCountryReducer,
    users: userReducer,
    variableStats: variableStatsReducer,
    interferences: interferencesReducer,
    availability: availabilityStatsReducer,
    maxAvailablePopulation: maxAvailablePopulationReducer,
    analysisReport: analysisReportReducer,
    analysisConfig: analysisConfigReducer,
  });

export default createRootReducer;
